export default {
    sessionData: {
        logoutReasonKey: 'logout-error-msg',
    },
};
